import type { MaybeRefOrGetter } from 'vue';
import { toValue } from 'vue';

import { t } from '../../../locale';
import type { ValidationMessage, ValidationRule } from '../useValidation.types';
import isDefined from '../utils/isDefined';

interface Config {
  max: MaybeRefOrGetter<number>;
  message?: ValidationMessage;
  trim?: boolean;
}

export default function maxLength(config: Config): ValidationRule {
  return {
    name: 'maxLength',
    validator(_value) {
      const max = toValue(config.max);
      const value = toValue(_value);

      if (!isDefined(value)) {
        return true;
      }

      let valueString = String(value);

      if (config.trim) {
        valueString = valueString.trim();
      }

      return valueString.length <= max;
    },
    message: config.message || (() => t('ll.validation.maxLength', { max: String(toValue(config.max)) })),
  };
}
